export default __webpack_public_path__ + "cd7e6214e16bbb99ebc287208b31fb6c.png";